import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SupplierApi } from '../api/supplier.api';
import { switchMap, map } from 'rxjs/operators';

import { SupplierData, Supplier } from '../../../interfaces/masters/supplier' ;
@Injectable()
export class SupplierService extends SupplierData {

    constructor(private api: SupplierApi) {
      super();
    }
  
  
    list(url: string): Observable<Supplier[]> {
      return this.api.list(url);
    }
    listAny(url: string): Observable<any[]> {
      
      return this.api.listAny(url);
    }
  
    getById(url:string): Observable<Supplier>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<Supplier[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Supplier): Observable<Supplier> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
    
    //UploadData      
    postData(url: string, data:any[]): Observable<any> {
      return this.api.addData(url,data);
    }
  }
  